import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Account } from '../../models';

export interface AuthState {
  isLoggedIn?: boolean;
  logging?: boolean;
  error?: string;
  isDisable?: boolean;
}

const initialState: AuthState = {
  isLoggedIn: false,
  logging: false,
  error: undefined,
  isDisable: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsDisable(state, action: PayloadAction<boolean>){
      state.isDisable = action.payload
    },
    login(state, action: PayloadAction<Account>) {
      state.logging = true;
      state.error = ""
    },
    loginSuccess(state) {
      state.logging = false;
      state.isLoggedIn = true;
    },
    loginFailed(state, action: PayloadAction<string>) {
      state.logging = false;
      state.error = action.payload;
    },
    logout(state) {
      state.isLoggedIn = false;
    },
  },
});

export const authActions = authSlice.actions;

export const selectIsLoggedIn = (state: any) => state.auth.isLoggedIn;
export const selectLogging = (state: any) => state.auth.logging;
export const selectError = (state: any) => state.auth.error;
export const selectIsDisable = (state: any) => state.auth.isDisable;

const authReducer = authSlice.reducer;
export default authReducer;
